type DataWithIdAndChildren = { id: string; parentId?: string; children?: DataWithIdAndChildren[] }
type DataWithIdAndOptionalParent = { id: string; parentId?: string }
export function getSiblings<T extends DataWithIdAndChildren>(
    id: string,
    dataFlatMap: Record<string, T>,
    sortedData: T[]
) {
    let curData = dataFlatMap[id]
    const path: string[] = []
    while (curData && curData.parentId && curData.parentId !== "null") {
        curData = dataFlatMap[curData.parentId]
        path.push(curData.id)
    }
    let curSiblings: T[] = sortedData
    for (const pathStep of path.reverse()) {
        curSiblings = (curSiblings.find((data) => data.id === pathStep)?.children || []) as T[]
    }
    return curSiblings
}

export function getAncestors<T extends DataWithIdAndOptionalParent>(
    id: string,
    dataFlatMap: Record<string, T>
) {
    const ancestorIds: T[] = []
    let curData = dataFlatMap[id]
    while (curData && curData.parentId && curData.parentId !== "null") {
        curData = dataFlatMap[curData.parentId]
        if (curData) {
            ancestorIds.push(curData)
        }
    }
    return ancestorIds
}
